var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-layout",on:{"click":_vm.toggleMenu}},[_c('Navbar',{staticClass:"navbar-container"}),_c('div',{staticClass:"bg"},[_c('section',[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }